import { Variant } from '../typography/model';

export const CHECKBOX_LABEL_TYPOGRAPHY_VARIANT: Variant = 'caption';
export const CHECKBOX_LABEL_BORDER_WIDTH = 1;
export const CHECKBOX_LABEL_VERTICAL_SPACING = 1;
export const CHECKBOX_LABEL_HORIZONTAL_SPACING = 2;
